(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcements-bar"]) return;
  try {
    
  if (!customElements.get('scheduled-announcement')) {
    customElements.define('scheduled-announcement', class extends HTMLElement {
      connectedCallback() {
        this.sync = this.updateMessage.bind(this);
        if (!this.querySelector('p') || !this.querySelector('template')) {
          this.readyObserver = new MutationObserver(this.sync);
          this.readyObserver.observe(this, { childList: true, subtree: true });
        }
        document.addEventListener('visibilitychange', this.sync);
        window.addEventListener('pageshow', this.sync);
        this.sync();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.readyObserver) this.readyObserver.disconnect();
        document.removeEventListener('visibilitychange', this.sync);
        window.removeEventListener('pageshow', this.sync);
      }
      updateMessage() {
        clearTimeout(this.timer);
        if (this.querySelector('p') && this.querySelector('template') && this.readyObserver) this.readyObserver.disconnect();
        var end = Date.parse(this.dataset.expires);
        if (!Number.isFinite(end)) return;
        var now = Date.now();
        if (now >= end && this.dataset.ended !== 'true') {
          var text = this.querySelector('p');
          var fallback = this.querySelector('template');
          if (text && fallback) {
            text.replaceChildren(fallback.content.cloneNode(true));
            this.dataset.ended = 'true';
          }
        }
        if (now < end) this.timer = setTimeout(this.sync, Math.min(end - now, 2147483647));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            this.classList.add('products-loaded');
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
